import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-connectivity-status',
  templateUrl: './connectivity-status.component.html',
  styleUrls: ['./connectivity-status.component.css']
})
export class ConnectivityStatusComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: 'offline' | 'server-down';
    }
  ) { }
}